import { render, staticRenderFns } from "./header-pc.vue?vue&type=template&id=4d22ad99&"
import script from "./header-pc.vue?vue&type=script&lang=js&"
export * from "./header-pc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports